import { defaultAxiosConfig } from "./apiConfig";
const oneByOneBackendProxy = require("axios");

oneByOneBackendProxy.interceptors.response.use(
  response => {
    let backendResponse = response.data;
    if (backendResponse.statusCode != 200) {
      return Promise.reject(backendResponse);
    } else {
      return backendResponse;
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export const OneByOneRestfulGet = (
  resource,
  queryParams,
  axiosConfig = defaultAxiosConfig
) => {
  return oneByOneBackendProxy
    .get(resource, {
      ...{
        params: queryParams
      },
      ...axiosConfig
    })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return error.data;
    });
};

export const OneByOneRestfulPost = (
  resource,
  data,
  axiosConfig = defaultAxiosConfig
) => {
  return oneByOneBackendProxy
    .post(resource, data, axiosConfig)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return error.data;
    });
};
